import { useState } from 'react';
import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  Flex,
  InputBox,
  PrimaryButton,
  Typography,
} from '@banhala/ui-kit';
import { validateEmail } from '../../../EmailLogin/validation';

type SubmitParam = {
  /** 이메일로 로그인 재제출. 실패 시 throw하면 드로어를 유지한다. */
  onSubmit: (email: string) => Promise<void>;
};

const RegisterEmailForm = ({
  onSubmit,
  onSuccess,
}: SubmitParam & { onSuccess: () => void }) => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const isValid = validateEmail(email) == null;

  const handleSubmit = async () => {
    if (submitting || !isValid) return;
    setSubmitting(true);
    try {
      await onSubmit(email);
      // 성공 시에만 드로어를 닫는다. (실패 시 유지 → 재시도 가능)
      onSuccess();
    } catch {
      // 에러 토스트는 onSubmit이 담당. 드로어를 유지하고 버튼만 다시 활성화.
      setSubmitting(false);
    }
  };

  return (
    <Flex padding={{ horizontal: 16, top: 8, bottom: 24 }} gap={16}>
      <Typography type={'h4'} color={'content_primary'}>
        {'이메일을 입력해 주세요'}
      </Typography>
      <InputBox
        type={'underline'}
        placeholder={'이메일 입력'}
        value={email}
        onChangeText={setEmail}
        keyboardType={'email-address'}
        autoCapitalize={'none'}
      />
      <PrimaryButton
        variant={'fill'}
        color={'gray'}
        size={'xlarge'}
        state={submitting ? 'loading' : isValid ? undefined : 'disabled'}
        onPress={handleSubmit}
      >
        {'가입하기'}
      </PrimaryButton>
    </Flex>
  );
};

/**
 * 소셜 가입 보완 드로어 — 이메일만 (카카오/애플 NeedEmail). (webview RegisterDrawer 대응)
 * 입력 이메일을 param.onSubmit(재제출)에 넘기고, 성공 시에만 닫는다.
 */
export const useRegisterEmailBottomSheet = createUseBottomSheetModal<
  void,
  SubmitParam
>(({ confirm, cancel, param }) => (
  <BottomSheetContainer title={'가입하기'} onPressClose={cancel}>
    <RegisterEmailForm onSubmit={param.onSubmit} onSuccess={confirm} />
  </BottomSheetContainer>
));
